import { useRef, useState } from "react";
import { Camera, X, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { fileToJpegBase64 } from "@/lib/veeder";

const MAX = 3;

export function PhotoPicker({ photos, setPhotos, setUploading, t, testid }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(0);
  const [err, setErr] = useState("");

  const add = async (files) => {
    const list = Array.from(files || []).slice(0, MAX - photos.length);
    if (!list.length) return;
    setErr(""); setBusy((n) => n + list.length); setUploading?.(true);
    for (const f of list) {
      try {
        const b64 = await fileToJpegBase64(f, 1600);
        const { photo_id } = await api.uploadPhoto(b64);
        setPhotos((p) => [...p, { id: photo_id, preview: `data:image/jpeg;base64,${b64}` }].slice(0, MAX));
      } catch (e) { setErr(apiError(e) || t("Couldn't add that photo. Try another one.")); }
      setBusy((n) => n - 1);
    }
    setUploading?.(false);
    if (input.current) input.current.value = "";
  };

  return (
    <div className="photo-pick" data-testid={`${testid}-photos`}>
      <div className="photo-row">
        {photos.map((p, i) => (
          <div key={p.id} className="photo-thumb" data-testid={`${testid}-photo-${i}`}>
            <img src={p.preview} alt="" />
            <button type="button" aria-label={t("Remove photo")} data-testid={`${testid}-photo-remove-${i}`}
              onClick={() => setPhotos(photos.filter((x) => x.id !== p.id))}><X size={12} /></button>
          </div>
        ))}
        {Array.from({ length: busy }).map((_, i) => <div key={`b${i}`} className="photo-thumb photo-busy"><Loader2 size={18} className="spin" /></div>)}
        {photos.length + busy < MAX && (
          <button type="button" className="photo-add" data-testid={`${testid}-photo-add`} onClick={() => input.current?.click()}>
            <Camera size={16} />{photos.length ? t("Add") : t("Add photo")}
          </button>
        )}
      </div>
      <input ref={input} type="file" accept="image/*" multiple hidden data-testid={`${testid}-photo-input`} onChange={(e) => add(e.target.files)} />
      <div className="field-hint">{t("Up to 3 photos, like a screenshot or the console.")}</div>
      {err && <div className="form-error" data-testid={`${testid}-photo-error`}>{err}</div>}
    </div>
  );
}
